import { BaseApi } from "@newview/infrastructure";
export abstract class SystemBaseApi extends BaseApi {
    public get ProxyName(): any {
        return 'SystemApi';
    }
  
}